import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RewatchVideoDTO, WebinarClient } from 'src/app/Services/WOWApi.Service';

/**
 * The page an emailed "rewatch" link opens (see ShareWebinarDialogComponent). Any logged-in
 * user can land here - access to the actual video is enforced server-side by GetRewatchVideo,
 * which only returns a result for seat purchasers and the webinar's host.
 */
@Component({
    selector: 'app-rewatch-webinar',
    templateUrl: './rewatch-webinar.component.html',
    styleUrls: ['./rewatch-webinar.component.css'],
    standalone: false
})
export class RewatchWebinarComponent implements OnInit {
  loading = true;
  forbidden = false;
  notFound = false;
  video: RewatchVideoDTO = null;
  safeSrc: SafeResourceUrl;

  constructor(
    private activatedRoute: ActivatedRoute,
    private webinarClient: WebinarClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    const webinarId = Number(this.activatedRoute.snapshot.params.webinarId);
    if (!webinarId) {
      this.loading = false;
      this.notFound = true;
      return;
    }

    this.webinarClient.getRewatchVideo(webinarId).subscribe({
      next: (video) => {
        this.loading = false;
        if (!video || !video.videoPath) {
          this.notFound = true;
          return;
        }
        this.video = video;
        this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(video.videoPath);
      },
      error: (err) => {
        this.loading = false;
        if (err?.status === 403) {
          this.forbidden = true;
        } else {
          this.notFound = true;
        }
      }
    });
  }
}
